export function initFindOfficeViewToggle() {
  // Clean initial state (hidden lists/maps)
  document.querySelectorAll(".find-office").forEach((container) => {
    const mapEl = container.querySelector(".find-office-map");
    const listEl = container.querySelector(".find-office-list");
    if (mapEl) mapEl.hidden = true;
    if (listEl) listEl.hidden = false;

    container
      .querySelectorAll(".find-office-pagination__views .view-btn")
      .forEach((btn) => {
        btn.classList.remove("active");
        btn.setAttribute("aria-pressed", "false");
      });

    const listBtn = container.querySelector(
      '.find-office-pagination__views .view-btn[data-view="list"]'
    );
    if (listBtn) {
      listBtn.classList.add("active");
      listBtn.setAttribute("aria-pressed", "true");
    }
  });

  // Click view toggle
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".find-office-pagination__views .view-btn");
    if (!btn) return;

    e.preventDefault();

    const container =
      btn.closest(".find-office") ||
      btn.closest(".find-office-pagination")?.parentElement;
    if (!container) return;

    const mapEl = container.querySelector(".find-office-map");
    const listEl = container.querySelector(".find-office-list");
    const view = btn.dataset.view; // "list" | "map"

    if (view === "map") {
      if (mapEl) mapEl.hidden = false;
      if (listEl) listEl.hidden = true;
    } else if (view === "list") {
      if (listEl) listEl.hidden = false;
      if (mapEl) mapEl.hidden = true;
    }

    // Update active state
    container
      .querySelectorAll(".find-office-pagination__views .view-btn")
      .forEach((b) => {
        const isActive = b === btn;
        b.classList.toggle("active", isActive);
        b.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
  });
}
